// eslint-disable-next-line
export const noop = () => {};
